import { FC, useCallback, useMemo } from 'react';

import { Option, Select } from '@beeline/design-system-react/extracted-styles';

import { FeedbackType } from 'src/api/feedback';

import { labelsByFeedbackType } from './consts';

const options: Option<string>[] = Object.entries(labelsByFeedbackType).reduce<
  Option<string>[]
>((acc, item) => {
  acc.push({ id: item[0], value: item[1] });
  return acc;
}, []);

const emptyValues: Option<string>[] = [];

export interface FeedbackTypeSelectProps {
  value: FeedbackType | null;
  onChange: (value: FeedbackType) => void;
  testId?: string;
}

export const FeedbackTypeSelect: FC<FeedbackTypeSelectProps> = ({
  value,
  onChange,
  testId,
}) => {
  const values = useMemo((): Option<string>[] => {
    return value
      ? [
          {
            id: value,
            value: labelsByFeedbackType[value],
          },
        ]
      : emptyValues;
  }, [value]);

  const handleChange = useCallback(
    (nextValues: Option<string>[]) => {
      onChange(nextValues[0]?.id as FeedbackType);
    },
    [onChange],
  );

  return (
    <Select
      size='medium'
      label='Тип обращения'
      fullWidth
      placeholder='выберите тип обращения'
      noOptionsText='нет типов обращения'
      options={options}
      values={values}
      onChange={handleChange}
      multiple={false}
      dataTestId={testId}
    />
  );
};
